import { getLocaleFirstDayOfWeek } from '@angular/common';
import { inject, Injectable, LOCALE_ID } from '@angular/core';
import { LuxonDateAdapter } from '@angular/material-luxon-adapter';

@Injectable()
export class CustomDateAdapter extends LuxonDateAdapter {
    private readonly localeId = inject(LOCALE_ID);

    override getFirstDayOfWeek(): number {
        return getLocaleFirstDayOfWeek(this.localeId);
    }
}
